import Cookies from 'js-cookie';

/**
 * This checks a loggedIn cookie for existence and a specific value.
 * If both are true, the user is logged in.
 * */
export default function (): boolean {
  const loggedInState = Cookies.get('loggedIn');
  const userExists = Cookies.get('user_v2') !== undefined;

  if (loggedInState === '1' && userExists) {
    return true;
  }

  return false;
}
